import { FC } from "react";

import {
  IColumnDef,
  IExtendableDto,
  RenderSubComponentModel,
} from "@ryde/shared";

import { IGridRowProps } from "../../core";
import { useTableWrapper } from "./hooks";
import { TableCellAdditions } from "./table-cell-additions";
import { TableContextWrapper } from "./table.context.wrapper";

interface ITableWrapperGenericProps {
  tableDefs: IColumnDef<IExtendableDto, unknown>[];
  GridRowRenderer?: FC<IGridRowProps<IExtendableDto>>;
  RenderSubComponent?: RenderSubComponentModel<IExtendableDto>;
  onScrollEnd?: () => void;
}

export const TableWrapperGeneric: FC<ITableWrapperGenericProps> = ({
  tableDefs,
  GridRowRenderer,
  RenderSubComponent,
  onScrollEnd,
}) => {
  const { isTableReady, isViewApplying } = useTableWrapper({
    tableDefs: tableDefs as IColumnDef<IExtendableDto, unknown>[],
  });

  return (
    <>
      {!isViewApplying && Boolean(isTableReady) && (
        <TableContextWrapper
          tableDefs={tableDefs}
          GridRowRenderer={GridRowRenderer}
          RenderSubComponent={RenderSubComponent}
          onScrollEnd={onScrollEnd}
        />
      )}
      <TableCellAdditions />
    </>
  );
};
